module.exports = __webpack_public_path__ + "img/hand-holding-dollar.6c838e2b.svg";